import * as React from 'react';

import '../../assets/style.css';

export default function PersonImageNormal({image, name, description, text, title=null}){

    return (
            
        <div className="flex-row" style={{width:"70%", margin:"auto"}}>
        <div className="flex-column" style={{alignItems:"center", gap:"1rem"}}>
            <div className="image-square">
                <img style={{width:"80%"}} src={image}></img>
            </div>
            <div className="pillbox-huge button-huge pillbox-like" >
                <div style={{fontSize:"1.6rem"}}><span>{name}</span>, <div style={{fontFamily:'Instrumentserif Regular'}}>{title}</div></div>
            <div className="font-italic " style={{fontSize:"1.2rem"}}>{description}</div>
                
            </div>
        </div>
        <div className="person-image-text" style={{maxWidth:"60%", height:"100%", overflowY:"scroll", position:"relative"}}>
            <p>{text}</p>
        </div>
        </div>
    )
}